import { render } from "./PrerenderNavigation.vue?vue&type=template&id=74b3da14&scoped=true"
import script from "./PrerenderNavigation.vue?vue&type=script&lang=js"
export * from "./PrerenderNavigation.vue?vue&type=script&lang=js"

import "./PrerenderNavigation.vue?vue&type=style&index=0&id=74b3da14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b3da14"]])

export default __exports__